import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import bash2 from './assets/images/bash2.png';
import bash from './assets/images/bash.png';
import bash3 from './assets/images/bash3.png';
import bash4 from './assets/images/bash4.png';
import reactScreen from './assets/images/react-screen.png';
import yarn from './assets/images/yarn.png';

const ReactLesson3 = () => {
  const [language, changeLanguage] = useState("react");
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      cd documents
      
      `
    );

    const code1 = (
      'text',
      `
      npx create-react-app my-react-app
      
      `
    );
    const code2 = (
      'text',
      `
      cd my-react-app      
      `
    );
    const code3 = (
      'text',
      `
      npm start
      # or using yarn if you prefer:
      # yarn start     
      `
    );
    const code4 = (
      'text',
      `
      npm install --global yarn
      `
    );




  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
     
            <div className="alert alert-secondary" role="alert">
              <h3><strong>Setting up React Environment</strong></h3>
              <p>Setting up a React development environment involves a few steps to ensure you have the necessary tools and configurations to start building React applications. Here's a guide to setting up a basic React environment:</p>
              <h4>Prerequisites:</h4>
              <p>Node.js and npm (Node Package Manager) installed on your machine. You can download and install Node.js from the official website: <span className="text-primary">Node.js</span>.</p>
              <h4>Steps to Set Up a React Environment:</h4>
              <ol className="list-group list-group-numbered mb-4">
                <li className="list-group-item"><strong>Create a New React Application:</strong>
                  <ul className="list-group list-group-numbered">
                    <li className="list-group-item">Open your terminal or command prompt and go to your documents folder as follows:</li>
                    <li className="list-group-item">
                      <CopyBlock
                        language={"bash"}
                        text={code} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />
                      <p>This will bring you to the documents directory. If you are on <strong>Windows</strong> you might need to enter your computer profile name before you get to the documents directory.</p>
                    </li>
                    <li className="list-group-item">Use npx (comes with npm 5.2 and higher) or npm to create a new React app using <strong><em>create-react-app</em></strong>. Run the following command:</li>
                    <CopyBlock
                        language={"bash"}
                        text={code1} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />                      <p>Replace my-react-app with your preferred app name.</p>
                  </ul>
                </li>
                <li className="list-group-item"><strong>Navigate to the Created React App Directory:</strong>
                  <ul className="list-group list-group-numbered">
                    <li className="list-group-item">Once the app is created, navigate to the directory of your newly created React application:</li>
                    <CopyBlock
                        language={"bash"}
                        text={code2} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />                  </ul>
                </li>
                <li className="list-group-item"><strong>Start the Development Server:</strong>
                  <ul className="list-group list-group-numbered">
                    <li className="list-group-item">Inside the project directory, start the development server:</li>
                    <CopyBlock
                        language={"bash"}
                        text={code3} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />                    <li className="list-group-item">This command will launch the development server and open your React application in a browser window at <strong className="text-primary">http://localhost:3000</strong>. You'll see the default React app's welcome screen and you can open up your project in your favorite editor.</li>
                    <li className="list-group-item"><img className="img-fluid mb-2" src={reactScreen} alt="react" style={{width: '700px', height: '350px'}} /></li>
                  </ul>
                </li>
                <li className="list-group-item"><strong>Install yarn:</strong>
                  <ul className="list-group list-group-numbered">
                    <li className="list-group-item">
                      <p>If you prefer to use yarn, use the below command to install it globally.</p>
                      <CopyBlock
                        language={"bash"}
                        text={code4} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />                    </li>
                  </ul>
                </li>
              </ol>
              <p>This setup provides a basic environment to begin building React applications. As you progress, you might explore more advanced configurations, add libraries, and fine-tune the development environment based on your project requirements.</p>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
}

export default ReactLesson3;
